<template>
  <section class="p-2">
    <v-card>
      <v-card>
        <v-card-title class="d-flex justify-space-between p-0 m-0">
          <div class="ps-2 headingFontsize">Voucher Entry</div>
          <div>
            <bread-crumb :bread-crumbs="['Voucher Entry']" />
          </div>
        </v-card-title>
        <v-divider class="p-0 m-0 primary--text"></v-divider>
      </v-card>

      <v-card-text>
        <v-dialog persistent v-model="vocherDialog" width="800">
          <v-card>
            <v-toolbar color="secondary" dark flat dense>
              <span>Voucher Entry</span>
              <v-spacer></v-spacer>
              <v-btn depressed icon @click="closeVocherDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-form ref="form" v-model="valid">
              <v-row class="ms-1 me-1 mt-2">
                <v-col cols="12" md="6" lg="6" xs="12">
                  <label class="my-0 rounded labelFontsize required">
                    Ledger Head
                  </label>
                  <v-autocomplete
                    v-model="voucherEntry.gl_sub_head_code"
                    dense
                    outlined
                    item-text="text"
                    item-disabled="had_sub_list"
                    @input="getallLedgersBalance(voucherEntry.gl_sub_head_code)"
                    item-value="value"
                    placeholder="Select ledger head"
                    :rules="FieldRequired('Ledger Head')"
                    :items="ledgerIds"
                  >
                    <template v-slot:item="data">
                      <template class="border">
                        <v-list-item
                          dense
                          ripple
                          @mousedown.prevent
                          :class="
                            data.item.had_sub_list
                              ? 'light-gray primary--text'
                              : ''
                          "
                          v-if="data.item.isheader"
                        >
                          <v-list-item-content class="ma-0 pa-0">
                            <v-list-item-title class="d-flex ma-0 pa-0"
                              ><span class="pt-1 ps-3 font-weight-bold">{{
                                data.item.text
                              }}</span></v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                          dense
                          class="ps-6 border-list"
                          v-if="!data.item.isheader"
                        >
                          <v-list-item-content class="ma-0 ps-6 mt-2">
                            <v-list-item-title
                              ><v-icon class="pb-2"
                                >mdi-arrow-right-bottom</v-icon
                              >{{ data.item.text }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                      <v-divider></v-divider>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" class="mt-6" md="2" lg="2" xs="12">
                  <v-autocomplete
                    dense
                    outlined
                    v-model="voucherEntry.part_tran_type"
                    :items="debit_list"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="mt-6" md="4" lg="4" xs="12">
                  <v-text-field
                    class=""
                    placeholder="Ledger Balance"
                    dense
                    outlined
                    v-model="voucherEntry.ledger_balance"
                    disabled
                    item-text="txt"
                    item-value="val"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-radio-group
                  row
                  class="d-flex ms-6"
                  v-model="voucherEntry.selected_currency"
                >
                  <v-radio
                    label="Calc By (Ledger CCY)"
                    color="primary"
                    value="P"
                    class="mt-0 ms-3 m-auto"
                    inset
                    dense
                    hide-details
                  ></v-radio>
                  <v-radio
                    label="USD"
                    color="primary"
                    value="C"
                    class="mt-0 m-auto"
                    inset
                    dense
                    hide-details
                  ></v-radio>
                </v-radio-group>
              </v-row>
              <v-row class="ms-1 me-1 mt-2">
                <v-col cols="12" md="4" lg="4" xs="12">
                  <label class="my-0 rounded labelFontsize required">
                    Voucher Amount
                  </label>
                  <v-text-field
                    dense
                    v-model="voucherEntry.tran_amt"
                    @input="getVoucherexRates(voucherEntry.tran_amt)"
                    :disabled="voucherEntry.selected_currency == 'P'"
                    outlined
                    :background-color="
                      voucherEntry.selected_currency == 'P' ? '#F8F8F8' : ''
                    "
                    placeholder="Enter Amount"
                    :rules="FieldRequired('Voucher Amount')"
                  >
                    <template v-slot:prepend-inner class="pt-0"> </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="mt-6" lg="2" xs="12">
                  <v-text-field
                    dense
                    disabled
                    v-model="foriegn_cry"
                    outlined
                    placeholder="Currency"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4" lg="4" xs="12">
                  <label class="my-0 rounded labelFontsize required">
                    Local Currency
                  </label>
                  <v-text-field
                    dense
                    v-model="voucherEntry.lc_amt_cr"
                    :disabled="voucherEntry.selected_currency == 'C'"
                    :background-color="
                      voucherEntry.selected_currency == 'C' ? '#F8F8F8' : ''
                    "
                    @input="getVoucherexRates(voucherEntry.lc_amt_cr)"
                    outlined
                    placeholder="Enter Amount"
                    :rules="FieldRequired('Local Currency')"
                  >
                    <template v-slot:prepend-inner class="pt-0"> </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="mt-6" lg="2" xs="12">
                  <v-text-field
                    dense
                    disabled
                    v-model="voucherEntry.trn_currency"
                    outlined
                    placeholder="Currency"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="ms-1 me-1 mt-2">
                <v-col cols="12" md="5" lg="5" xs="12">
                  <label class="my-0 rounded labelFontsize required">
                    Exchange Rate
                  </label>
                  <v-text-field
                    dense
                    v-model="voucherEntry.usd_rate"
                    outlined
                    placeholder="Enter Amount"
                    :rules="FieldRequired('Exchange Rate')"
                  >
                    <template v-slot:prepend-inner class="pt-0"> </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="mt-6" lg="2" xs="12">
                  <v-text-field
                    dense
                    disabled
                    v-model="voucherEntry.trn_currency"
                    outlined
                    placeholder="Currency"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <v-divider class="pa-0 mb-0"></v-divider>
            <v-card-actions class="ma-0 pt-0">
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                small
                color="primary"
                @click="SaveTempData()"
                class="text-capitalize me-3 mt-3 text-decoration-none float-right"
                ><v-icon class="me-2" small
                  >mdi-content-save-plus-outline</v-icon
                >Add Record
              </v-btn>
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
                color="primary"
                outlined
                @click="closeVocherDialog()"
                ><v-icon small>mdi-close</v-icon>cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-data-table
          fixed-header
          height="55vh"
          :headers="headers"
          :search="search"
          :items="voucherTableData"
          dense
          class="mt-5"
        >
          <template v-slot:top>
            <v-row class="mb-1">
              <v-col>
                <v-btn
                  color="primary"
                  class="ms-3"
                  small
                  depressed
                  @click="openDialog()"
                >
                  <v-icon class="me-2" small
                    >mdi-content-save-plus-outline</v-icon
                  >
                  Add Record
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  depressed
                  small
                  @click="openSubmitDialog()"
                  color="success"
                  class="text-capitalize float-right mb-4 me-2"
                >
                  <v-icon left dark> mdi-check-circle </v-icon> Submit the
                  voucher Entry
                </v-btn>
                <v-btn
                  depressed
                  @click="openClearVocher()"
                  small
                  color="error"
                  class="text-capitalize float-right mb-4 me-2"
                >
                  <v-icon left dark> mdi-close-circle </v-icon> Clear the
                  voucher Entry
                </v-btn>
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.gl_sub_head_code="{ item }">
            {{ returnLedgername(item.gl_sub_head_code) }}
          </template>
          <template v-slot:item.debit="{ item }">
            {{ item.part_tran_type == "Dr" ? item.tran_amt : 0 }}
          </template>
          <template v-slot:item.credit="{ item }">
            {{ item.part_tran_type == "Cr" ? item.tran_amt : 0 }}
          </template>
          <template v-slot:item.lc_amt_cr="{ item }">
            {{ item.lc_amt_cr }} {{ item.trn_currency }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              small
              color="primary"
              class="mr-2"
              @click="(dialogDelete = true), (deleteId = item.id)"
            >
              mdi-trash-can-outline
            </v-icon>
          </template>
        </v-data-table>

        <!-- add api partner -->
        <v-dialog persistent v-model="dialog" width="400">
          <v-card
            width="600"
            outlined
            class="rounded-lg"
            color="backgroundcolor"
          >
            <v-form ref="submitform" v-model="valid" class="mt-5">
              <v-row class="ms-1 me-1">
                <v-col>
                  <label class="my-0 rounded labelFontsize required">
                    Total
                  </label>
                  <v-text-field
                    class=""
                    v-model="SubmitVoucherdata.total_credit"
                    dense
                    outlined
                    disabled
                    suffix="Dr"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ms-1 me-1">
                <v-col>
                  <v-text-field
                    disabled
                    v-model="SubmitVoucherdata.total_debit"
                    dense
                    outlined
                    suffix="Cr"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ms-1 me-1">
                <v-col>
                  <label class="my-0 rounded labelFontsize required">
                    Effective Date
                  </label>
                  <v-text-field
                    type="date"
                    v-model="SubmitVoucherdata.voucherDate"
                    dense
                    outlined
                    :rules="FieldRequired('Effective Date')"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="ms-1 me-1">
                <v-col>
                  <label class="my-0 rounded labelFontsize required">
                    Remarks
                  </label>
                  <v-textarea
                    v-model="SubmitVoucherdata.remarks"
                    dense
                    outlined
                    placeholder="Enter Remarks"
                    :rules="FieldRequired('Remarks')"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row no-gutters>
                <v-col class="mb-1 me-2">
                  <v-btn
                    depressed
                    @click="SubmitVoucherForm()"
                    small
                    color="primary"
                    class="text-capitalize text-decoration-none float-right"
                    ><v-icon class="me-2" small
                      >mdi-content-save-plus-outline</v-icon
                    >Submit
                  </v-btn>
                  <v-btn
                    depressed
                    small
                    color="primary"
                    @click="dialog = false"
                    class="text-capitalize text-decoration-none me-2 float-right"
                    ><v-icon class="me-2" small>mdi-close-circle-outline</v-icon
                    >Cancel
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- delete dialog -->
        <v-dialog persistent v-model="dialogDelete" width="500">
          <v-card>
            <v-card-title class="border border-bottom">Delete</v-card-title>
            <v-card-text class="h5 py-3"
              >Are you sure you want to
              {{ deleteId ? "Delete" : "Clear" }}?</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                small
                color="primary"
                outlined
                @click="deleteItemConfirm"
              >
                <v-icon>mdi-check</v-icon>
              </v-btn>
              <v-btn
                depressed
                small
                color="primary"
                outlined
                @click="(dialogDelete = false), (deleteId = null)"
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import alerts from "@/mixins/alerts";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import setupService from "@/services/SetupService/setupService";
import commonService from "@/services/CommonService/commonService.js";
import { partnerRoute } from "@/utils/validation.js";
import { FieldRequired, FieldNumbRequired } from "@/utils/validation.js";
import treasuryService from "@/services/TreasuryService/treasuryService.js";
export default {
  name: "Voucher Entry",
  mixins: [alerts],
  components: {
    BreadCrumb,
    OverlayPageVue,
  },

  data: () => {
    return {
      FieldRequired,
      FieldNumbRequired,
      ...partnerRoute,
      dialog: false,
      loader: false,
      valid: true,
      dialogDelete: false,
      vocherDialog: false,
      editedIndex: -1,
      selectedCountry: "",
      country_options: [],
      currencyOptions: [],
      ledgerIds: [],
      deleteId: null,
      search: "",
      foriegn_cry: "USD",
      selected_currency: "P",
      voucherEntry: {
        ledger_balance: "",
        gl_sub_head_code: "",
        part_tran_srl_num: "",
        part_tran_type: "Cr",
        tran_amt: 0,
        tran_date: new Date().toISOString(),
        tran_rmks: "",
        effective_date: null,
        trn_currency: "",
        ex_rate: 0,
        usd_rate: 0,
        lc_amt_cr: 0,
        usd_amt: 0,
        selected_currency: "P",
      },
      defaultVoucherEntry: {
        ledger_balance: "",
        gl_sub_head_code: "",
        part_tran_srl_num: "",
        part_tran_type: "Cr",
        tran_amt: 0,
        tran_date: new Date().toISOString(),
        tran_rmks: "",
        effective_date: null,
        trn_currency: "",
        ex_rate: 0,
        usd_rate: 0,
        lc_amt_cr: 0,
        usd_amt: 0,
        selected_currency: "P",
      },
      SubmitVoucherdata: {
        total_credit: 0,
        total_debit: 0,
        voucherDate: new Date().toISOString().substring(0, 10),
        remarks: "",
      },
      SubmitDefaultVoucherEntry: {
        total_credit: 0,
        total_debit: 0,
        voucherDate: new Date().toISOString().substring(0, 10),
        remarks: "",
      },
      voucherTableData: [],
      selectedItems: {
        country: "",
        payment_mode: "",
        partner: "",
      },

      headers: [
        { text: "Id", value: "id" },
        { text: "District/Agent", value: "gl_sub_head_code" },
        { text: "Dr", value: "debit" },
        { text: "Cr", value: "credit" },
        { text: "Settle Rate", value: "usd_rate" },
        { text: "Settle Amount", value: "lc_amt_cr" },
        { text: "Delete", value: "actions" },
      ],

      debit_list: ["Cr", "Dr"],
      // applyLedger: ["ALL CCY", "USD Ledger", "MYR", "Local ONly"],
      ledger_obj: [],
    };
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
  },
  mounted() {
    // this.getBeneCountryList();
    this.getallLedgersDropdown();
  },
  watch: {
    "voucherEntry.gl_sub_head_code"(val) {
      if (val) {
        this.ledger_obj.map((ele) => {
          if (ele.ledger_id == val) {
            this.voucherEntry.trn_currency = ele.currency_code;
          } else {
            ele.sub_ledger_list.forEach((text) => {
              if (text.ledger_id == val) {
                this.voucherEntry.trn_currency = ele.currency_code;
              }
            });
          }
        });
      }
    },
  },
  methods: {
    async SubmitVoucherForm() {
      if (this.$refs.submitform.validate()) {
        this.voucherTableData.forEach((ele) => {
          ele["tran_rmks"] = this.SubmitVoucherdata.remarks;
          ele["effective_date"] = this.SubmitVoucherdata.voucherDate;
        });
        try {
          const responseData = await treasuryService.SubmitVoucherForm(
            this.voucherTableData
          );
          if (responseData.data.status_code === 200) {
            this.showAlertSuccess(responseData.data.message);
            this.closeSubmitVoucherDig();
            this.voucherTableData = [];
          } else {
            this.showAlertError(responseData.data.message);
          }
        } catch (e) {
          console.error(e);
        }
      }
    },
    openSubmitDialog() {
      this.SubmitVoucherdata = Object.assign(
        {},
        this.SubmitDefaultVoucherEntry
      );
      if (this.voucherTableData.length > 0) {
        console.log();
        this.voucherTableData.forEach((ele) => {
          if (ele.part_tran_type == "Cr") {
            this.SubmitVoucherdata.total_credit =
              parseInt(this.SubmitVoucherdata.total_credit) +
              parseInt(ele.tran_amt);
          } else if (ele.part_tran_type == "Dr") {
            this.SubmitVoucherdata.total_debit =
              parseInt(this.SubmitVoucherdata.total_debit) +
              parseInt(ele.tran_amt);
          }
          this.SubmitVoucherdata.remarks =
            this.SubmitVoucherdata.remarks +
            `@${this.returnLedgername(ele.gl_sub_head_code)}=${ele.tran_amt} ${
              ele.part_tran_type
            }`;
        });

        this.dialog = true;
      }
    },
    returnLedgername(val) {
      const data = this.ledgerIds.filter((ele) => {
        if (ele.value === val) {
          return ele.text;
        }
      });
      return data[0].text;
    },
    SaveTempData() {
      if (this.$refs.form.validate()) {
        const payload = { ...this.voucherEntry };
        payload.id =
          this.voucherTableData.length > 0
            ? this.voucherTableData.length + 1
            : 1;
        this.voucherTableData.push(payload);
        this.closeVocherDialog();
        this.voucherEntry = Object.assign({}, this.defaultVoucherEntry);
      }
    },
    openDialog() {
      this.vocherDialog = true;
    },
    closeVocherDialog() {
      this.vocherDialog = false;
      this.$refs.form.resetValidation();
    },
    closeSubmitVoucherDig() {
      this.dialog = false;
      this.SubmitVoucherdata = Object.assign(
        {},
        this.SubmitDefaultVoucherEntry
      );
    },
    openClearVocher() {
      if (this.voucherTableData.length > 0 && !this.deleteId) {
        this.$refs.submitform.reset();
        this.dialogDelete = true;
      }
    },
    async downloadExcelsheet() {
      if (this.routeData) {
        this.exportToExcel(this.headers, this.routeData, "partner Route");
      }
    },
    async getallLedgersDropdown() {
      try {
        const responseData = await setupService.getallLedgersDropdown();
        if (responseData.data.status_code === 200) {
          responseData.data.data.map((ele) => {
            this.ledgerIds.push({
              text: ele.name,
              value: ele.ledger_id,
              isheader: true,
              had_sub_list: ele.sub_ledger_list.length > 0 ? true : false,
            });
            if (ele.sub_ledger_list.length > 0) {
              ele.sub_ledger_list.map((sub_ele) => {
                this.ledgerIds.push({
                  text: sub_ele.name,
                  value: sub_ele.ledger_id,
                  isheader: false,
                });
              });
            }
          });
          console.log("this.ledgerIds", this.ledgerIds);
        }

        this.ledger_obj = responseData.data.data;
      } catch (e) {
        console.error(e);
      }
    },
    isFieldClearable(fieldName) {
      return (
        this.selectedItems[fieldName] !== "" &&
        this.selectedItems[fieldName] !== null
      );
    },
    getfilterdataBycntry(selected_country) {
      if (selected_country) {
        this.getPaymentMode(selected_country, true);
        this.getPartnerType(selected_country, true);
      }
    },
    getformDropDetails(selected_country) {
      if (selected_country) {
        this.getPaymentMode(selected_country, false);
        this.getPartnerType(selected_country, false);
        this.getcurrencyList(selected_country);
      }
    },
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    onSubmitFor() {
      if (this.partnerRoute.id) {
        // console.log("details");
        this.update();
      } else {
        // console.log("else");
        this.save();
        // // console.log('update')
      }
    },
    resetValidation() {
      if (this.$refs.Addform) {
        this.$refs.Addform.reset();
      }
    },
    openFormDialog() {
      this.dialog = true;
      (this.editedIndex = -1), this.resetValidation();
      this.partnerRoute = {
        partner: "",
        country: "",
        currency: "",
        payment_mode: "",
        is_exrate_by_partner: false,
        exrate: 0,
        is_batch_push: false,
        is_active: false,
      };
    },
    editItem(item) {
      this.editedIndex = this.routeData.indexOf(item);
      this.dialog = true;
      this.partnerRoute.country = item.country_data
        ? item.country_data.iso_alpha3
        : null;
      this.getPaymentMode(this.partnerRoute.country, false);
      this.getPartnerType(this.partnerRoute.country, false);
      this.getcurrencyList(this.partnerRoute.country);
      this.partnerRoute.partner = item.partner;
      this.partnerRoute.id = item.id;
      this.partnerRoute.is_active = item.is_active;
      this.partnerRoute.is_batch_push = item.is_batch_push;
      this.partnerRoute.is_exrate_by_partner = item.is_exrate_by_partner;
      this.partnerRoute.payment_mode = item.payment_mode_data
        ? item.payment_mode_data.value_code
        : null;
      this.partnerRoute.currency = item.currency_data
        ? item.currency_data.currency_code
        : null;
      // console.log(this.partnerRoute);
      // this.$refs.form.resetValidation();
    },
    closeDialog() {
      this.dialog = false;
      this.method_options = [];
      this.partner_options = [];
      this.$refs.form.reset();
    },
    deleteItemConfirm() {
      if (this.deleteId) {
        this.voucherTableData.splice(
          this.voucherTableData.length > 1 ? this.deleteId - 1 : this.deleteId,
          1
        );
        console.log("this.voucherTableData", this.voucherTableData);
        this.dialogDelete = false;
        this.deleteId = null;
      } else {
        this.voucherTableData = [];
        this.dialogDelete = false;
      }
    },
    async save() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        try {
          const responseData = await setupService.AddPartnerRouteData(
            this.partnerRoute
          );
          if (responseData.data.status_code == 200) {
            this.showAlertSuccess(responseData.data.message);
            this.getAllPartnerRoutes();
            this.dialog = false;
          } else {
            this.showAlertError(responseData.data.message);
            this.dialog = false;
          }
        } catch (e) {
          console.error(e);
          this.dialog = false;
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    async update() {
      // console.log(this.partnerRoute);
      try {
        const responseData = await setupService.updatePartnerRouteData(
          this.partnerRoute.id,
          this.partnerRoute
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getAllPartnerRoutes();
          this.dialog = false;
        } else {
          this.showAlertError(responseData.data.message);
        }
      } catch (e) {
        console.error(e);
        this.dialog = false;
        this.showAlertError("Something went wrong please try again later.");
      }
    },
    async getVoucherexRates(data) {
      const payload = {
        transfer_amount: data,
        calc_by: this.voucherEntry.selected_currency,
        payout_currency: this.voucherEntry.trn_currency,
        send_currency: "USD",
      };
      try {
        const response = await treasuryService.getVoucherexRates(payload);
        if (response.data.status_code === 200) {
          this.voucherEntry.ex_rate = response.data.data[0].exchangeRate;
          this.voucherEntry.usd_amt = response.data.data[0].transferAmount;
          // console.log("Voucher Rateresponse", response);
          if (this.voucherEntry.selected_currency == "C") {
            this.voucherEntry.lc_amt_cr = response.data.data[0].payoutAmount;
            this.voucherEntry.usd_rate = response.data.data[0].costRate;
          } else if (this.voucherEntry.selected_currency == "P") {
            this.voucherEntry.tran_amt = response.data.data[0].transferAmount;
            this.voucherEntry.usd_rate = response.data.data[0].costRate;
          }
        } else {
          this.showAlertError(response.data.message);
          this.currencyOptions = [];
        }

        // console.log("countrys", response);
      } catch (e) {
        this.currencyOptions = [];
        console.error(e);
        this.CountryList = [];
      }
    },
    async getallLedgersBalance(ledger_id) {
      try {
        const response = await setupService.getallLedgersBalance({
          ledger_id: ledger_id,
        });
        if (response.data.status_code === 200) {
          this.voucherEntry.ledger_balance = response.data.data[0].balance;
          // console.log("Balanceresponse", response);
        } else {
          this.showAlertError(response.data.message);
          this.currencyOptions = [];
        }

        // console.log("countrys", response);
      } catch (e) {
        this.currencyOptions = [];
        this.showAlertError("Something went wrong please try again later.");
        console.error(e);
        this.CountryList = [];
      }
    },
    async getBeneCountryList() {
      this.loader = true;
      try {
        const responseData = await commonService.getCountryBirthList();
        // console.log(responseData);
        this.loader = false;
        if (responseData.data.status_code === 200) {
          this.country_options = responseData.data.data.map((i) => {
            return {
              txt: i.country_name,
              val: i.iso_alpha3,
            };
          });
        }

        // console.log("getBeneCountryList", responseData);
      } catch (e) {
        this.loader = false;
        console.error(e);
      }
    },
  },
};
</script>
<style>
.required:after {
  content: " *";
  color: red;
}
</style>
